<template>
	<div>
		<ECommerceOrderButtonGodSomNy
			v-if="isGoodAsNew"
			:size="size"
			:disableAddToCart="unOrderable"
			:modalProps="content.modalProps"
			:ignoreStock="content.ignoreStock"
		/>

		<ECommerceOrderButtonPhone
			v-else-if="isNewDevice"
			:size="size"
			:disableAddToCart="unOrderable"
			:modalProps="content.modalProps"
		/>

		<ECommerceOrderButtonGeneric
			v-else
			:size="size"
			:disableAddToCart="unOrderable"
			:modalProps="content.modalProps"
			:ignoreStock="content.ignoreStock"
		/>
	</div>
</template>

<script>
import ECommerceProductMixin from "../ECommerceProductMixin/ECommerceProductMixin.js";
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
import { mapGetters } from "vuex";
import { ProductCategory } from "~/components/ecommerce/types/ProductCategory.js";

export default defineNuxtComponent({
	name: "ECommerceOrderButton",

	props: {
		size: {
			type: String,
			default: "m",
		},
	},

	mixins: [ECommerceProductMixin, GizmoComponentMixin],

	computed: {
		...mapGetters("shoppingCart", ["visibleCartItems"]),
		category() {
			return this.eCommerceProduct?.category;
		},
		isGoodAsNew() {
			return this.category == ProductCategory.GOOD_AS_NEW;
		},
		isNewDevice() {
			return [ProductCategory.PHONE, ProductCategory.WATCH, ProductCategory.TABLET].includes(this.category);
		},
		unOrderable() {
			return this.eCommerceProduct.unOrderable;
		},
	},
});
</script>
